module.exports = __webpack_public_path__ + "static/feature-242c63ba18e9645b57937de39bbb8d05.jpg";